import { render, staticRenderFns } from "./FormReadOnly.vue?vue&type=template&id=0522be1a"
import script from "./FormReadOnly.vue?vue&type=script&lang=js"
export * from "./FormReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports